import { useState } from "react";
import Button from "@shared/v2/Button";
import Dropdown from "@shared/v2/Dropdown";

import { useStateWithProps } from "./customHooks";
import { AngleDownSolidV6 } from "@shared/v2/Icomoon";

const SortMenu = ({ sortField, sortOrder, onSave }) => {
  const [sortMenuOpen, setSortMenuOpen] = useState(false);
  const [field, setField] = useStateWithProps(sortField);
  const [order, setOrder] = useStateWithProps(sortOrder || "asc");

  const saveSort = () => {
    onSave(field, order);
    setSortMenuOpen(false);
  };

  const update = (opt, setFn) => {
    const value = opt.value || "";

    setFn(value);
  };

  return (
    <>
      <Button
        className="tw-flex tw-items-center tw-gap-[4px]"
        schema="secondary"
        onClick={() => setSortMenuOpen(!sortMenuOpen)}
      >
        Sort By{sortField ? `: ${SortFields[sortField]}` : ""}
        <AngleDownSolidV6 />
      </Button>
      {sortMenuOpen && (
        <>
          <div className="tw-absolute tw-flex tw-items-center tw-right-112px tw-top-32px tw-flex-row tw-w-[353px] tw-h-[68px] tw-p-16px tw-z-50 tw-bg-white tw-shadow-modal">
            <div className="tw-mr-12px tw-w-[123px]">
              <Dropdown
                isSearchable={false}
                isClearable={false}
                options={fieldOptions}
                onChange={(e) => update(e, setField)}
                value={fieldOptions.find((f) => f.value === field)}
              />
            </div>
            <div className="tw-mr-20px tw-w-[123px]">
              <Dropdown
                isSearchable={false}
                isClearable={false}
                options={orderOptions}
                onChange={(e) => update(e, setOrder)}
                value={orderOptions.find((o) => o.value === order)}
              />
            </div>
            <Button disabled={!field} onClick={saveSort}>
              Save
            </Button>
          </div>
          <div
            className="tw-fixed tw-z-40 tw-inset-0 tw-bg-transparent"
            onClick={() => setSortMenuOpen(false)}
          />
        </>
      )}
    </>
  );
};

export default SortMenu;

const createOptions = (opts) => {
  return Object.entries(opts).map(([value, label]) => {
    return { value, label };
  });
};

const SortOrder = {
  asc: "Ascending",
  desc: "Descending",
};

const SortFields = {
  bedrooms: "Beds",
  price: "List Price",
  listDate: "List Date",
  squareFeet: "SQFT",
  bathsTotalDecimal: "Total Baths",
};

const orderOptions = createOptions(SortOrder);
const fieldOptions = createOptions(SortFields);
